module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/app-e9606bbe91517d45b2ecef8a5d0ba0b6.svg";